// The GPS logo on paper GPS SENDS OUT — quotes, tax invoices and progress-claim
// invoices (Karen Sweatman 2026-08-04). Same asset and same treatment as the
// report masthead (`ReportDocument.jsx`, which the Strike Rate and KPI packs
// already use), because everything that leaves the building should look like it
// came from one company. Robert's steer: copy what the strike rate report does.
//
// Deliberately an <img> rather than a CSS background: browsers do not print
// background images by default, and this exists to be printed. It survives
// print.css because that hides `.app-header` by name — it used to hide a bare
// `header`, which silently swallowed the KPI pack's logo band (2026-07-31).
const LOGO = "/images/logo3-clean.png";

function IssuerLogo({ height = "3rem", className = "mb-2" }) {
  return (
    <img
      className={`d-block ${className}`}
      src={LOGO}
      alt="Grayburn Property Services"
      style={{ height, width: "auto" }}
    />
  );
}

export default IssuerLogo;
